import { IsoCountryService, LocalisedCountry } from '../ISOCountryService'

export interface CountryOptionsProviderInterface {
  getCountryOptions(searchString: string): AutoCompleteItem[]
  toLocalisedCountries(countryOptions: AutoCompleteItem[]): LocalisedCountry[]
}

export type AutoCompleteItem = { label: string; value: string }

export class CountryOptionsProvider implements CountryOptionsProviderInterface {
  constructor(private isoCountryService: IsoCountryService) {
    this.getCountryOptions = this.getCountryOptions.bind(this)
    this.toLocalisedCountries = this.toLocalisedCountries.bind(this)
  }

  getCountryOptions(searchString: string): AutoCompleteItem[] {
    return this.isoCountryService.filterCountryNames(searchString).map(this.toCountryOption)
  }

  toLocalisedCountries(countryOptions: AutoCompleteItem[]): LocalisedCountry[] {
    return countryOptions.map(this.toLocalisedCountry)
  }

  private toCountryOption(country: LocalisedCountry): AutoCompleteItem {
    return {
      value: country.code,
      label: country.name,
    }
  }

  private toLocalisedCountry(countryOption: AutoCompleteItem): LocalisedCountry {
    return {
      code: countryOption.value,
      name: countryOption.label,
    }
  }
}
